// plugins/error-handler.js
import { defineNuxtPlugin } from 'nuxt/app'
import { useToast } from 'vue-toastification'

export default defineNuxtPlugin((nuxtApp) => {
  const toast = useToast()

  // Vue runtime errors
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error('[Vue Error Handler]', error, info, instance)
    // toast.error(error.message || 'Unexpected Vue error')
  }

  // Vue error hook
  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.error('[Nuxt Vue Error Hook]', error, info, instance)
    // toast.error(error.message || 'Unexpected Vue error')
  })

  // Nuxt application-level errors
  nuxtApp.hook('app:error', (error) => {
    console.error('[Nuxt App Error]', error)
    // toast.error(error.message || 'Application error occurred')
  })

  // Catch all unhandled promise rejections (client-side)
  if (process.client) {
    window.addEventListener('unhandledrejection', (event) => {
      console.error('[Unhandled Promise Rejection]', event.reason)
      // toast.error(event.reason?.message || 'Unhandled promise error')
    })
  }
})
